import { Orientation } from '../types';

export function getOrientation(width: number | undefined, height: number | undefined): Orientation {
    if (!width || !height) {
        return Orientation.Horizontal;
    }

    return (width / height < 1) ? Orientation.Vertical : Orientation.Horizontal;
}
